import STHeaderNotification from "../../../assets/styles/organisms/headerNotification.module.scss";
import Notification from "./Notification";
import { useNotification } from "./NotificationProvider";

const NotificationList = () => {
  const {
    state: { notifications },
  } = useNotification();

  const renderList = () => {
    if (!Array.isArray(notifications) || notifications.length === 0) {
      return (
        <div className={STHeaderNotification.emptyNotification}>
          通知はありません
        </div>
      );
    }
    return notifications.map((notification: any, index: number) => {
      const { id } = notification ?? {};
      return (
        <Notification
          isLastIndex={index === notifications.length - 1}
          {...notification}
          key={`notification_item_${id}`}
        />
      );
    });
  };

  return (
    <div className={STHeaderNotification.notificationList}>{renderList()}</div>
  );
};

export default NotificationList;
